import { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { LOGO } from "@/lib/config";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2, ArrowLeft } from "lucide-react";

function formatErr(detail) {
  if (detail == null) return "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return String(detail);
}

export default function AdminLogin() {
  const { login, user, ready } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (ready && user) navigate("/admin");
  }, [ready, user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      toast.error(formatErr(err.response?.data?.detail) || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-boco-navy bg-grid flex items-center justify-center px-5">
      <div className="max-w-sm w-full">
        <Link to="/" className="flex items-center gap-2 text-slate-300 hover:text-white text-sm mb-6 transition-colors"><ArrowLeft className="h-4 w-4" /> Back to site</Link>
        <div className="rounded-3xl bg-white p-8 shadow-2xl">
          <img src={LOGO} alt="BOCO BINS" className="mx-auto h-16 w-16 rounded-full object-cover" />
          <h1 className="mt-4 text-center font-display text-2xl font-black text-boco-navy">Owner Login</h1>
          <p className="mt-1 text-center text-sm text-slate-500">Manage service areas, bookings & leads</p>
          <form onSubmit={submit} className="mt-6 space-y-4">
            <div><Label className="text-boco-navy font-semibold">Email</Label><Input type="email" className="mt-1.5" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email" /></div>
            <div><Label className="text-boco-navy font-semibold">Password</Label><Input type="password" className="mt-1.5" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password" /></div>
            <button type="submit" disabled={loading} className="w-full rounded-full bg-boco-navy py-3 font-bold text-white hover:bg-boco-navylight transition-colors disabled:opacity-70 flex items-center justify-center gap-2" data-testid="login-submit">
              {loading ? <Loader2 className="h-5 w-5 animate-spin" /> : "Log In"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
